import Head from 'next/head';
import Link from 'next/link';
import Header from '../../components/Header';

export default function EmergencyPlumbingServicePage() {
  const phoneNumber = "(630) 715-8829";
  const companyName = "Partners Plumbing Co.";
  const serviceName = "Emergency Plumbing Service";
  const serviceArea = "Kane County, Geneva, Saint Charles, South Elgin";

  return (
    <>
      <Head>
        <title>{`Emergency Plumber Near Me | Geneva, IL & Kane County | ${companyName}`}</title>
        <meta name="description" content={`Emergency plumber Kane County - Fast response in Geneva, St Charles & South Elgin, IL. Licensed emergency plumber for burst pipes, water leaks, drain clogs. Call ${phoneNumber} now!`} />
        <meta name="keywords" content="emergency plumber near me, emergency plumber Kane County, emergency plumber Geneva IL, emergency plumber St Charles, local plumber near me, burst pipe emergency, emergency plumbing help Kane County, plumber open now, plumber Kane County" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://partnersinplumbing.com/services/emergency-plumbing-service" />
        <link rel="icon" href="/favicon.ico" />
        
        {/* Structured Data - LocalBusiness with Emergency Service and Aggregate Rating */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "@id": "https://partnersinplumbing.com",
            "name": companyName,
            "description": "Emergency plumbing services in Kane County, Illinois. Fast response for burst pipes, water leaks, drain emergencies, and all plumbing emergencies.",
            "url": "https://partnersinplumbing.com/services/emergency-plumbing-service",
            "telephone": phoneNumber,
            "image": "https://partnersinplumbing.com/images/optimized/logo-desktop.webp",
            "priceRange": "$$",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Kane County",
              "addressLocality": "Geneva",
              "addressRegion": "IL",
              "postalCode": "60177",
              "addressCountry": "US"
            },
            "areaServed": [
              {
                "@type": "City",
                "name": "Geneva",
                "address": { "@type": "PostalAddress", "addressRegion": "IL", "addressCountry": "US" }
              },
              {
                "@type": "City",
                "name": "St Charles",
                "address": { "@type": "PostalAddress", "addressRegion": "IL", "addressCountry": "US" }
              },
              {
                "@type": "City",
                "name": "South Elgin",
                "address": { "@type": "PostalAddress", "addressRegion": "IL", "addressCountry": "US" }
              },
              {
                "@type": "AdministrativeArea",
                "name": "Kane County",
                "address": { "@type": "PostalAddress", "addressRegion": "IL", "addressCountry": "US" }
              }
            ],
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Emergency Plumbing Services",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Emergency Plumbing Service",
                    "serviceType": "Emergency Plumber"
                  }
                }
              ]
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.9",
              "reviewCount": "187",
              "bestRating": "5",
              "worstRating": "1"
            },
            "openingHoursSpecification": {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
              "opens": "00:00",
              "closes": "23:59"
            }
          })}
        </script>
        
        {/* FAQ Schema for Featured Snippets */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "How fast can an emergency plumber get to my home in Kane County?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Our emergency plumbers typically arrive within 60 minutes for most locations in Kane County, including Geneva, St Charles, and South Elgin. Response times may vary based on current demand and weather conditions, but we prioritize emergency calls and dispatch the nearest available licensed plumber to your location immediately."
                }
              },
              {
                "@type": "Question",
                "name": "What qualifies as a plumbing emergency?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "A plumbing emergency is any situation that poses immediate risk to your property, health, or safety. This includes burst pipes causing active flooding, sewage backups, gas leaks, no hot water in winter, frozen pipes at risk of bursting, major water leaks, complete loss of water, and overflowing toilets that won't stop."
                }
              },
              {
                "@type": "Question",
                "name": "Do you provide 24/7 emergency plumbing service in Kane County?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes! We offer 24-hour emergency plumbing services, 7 days a week, including nights, weekends, and holidays. Plumbing emergencies don't wait for business hours, and neither do we. Our emergency plumbers in Kane County are always on call and ready to respond to your urgent plumbing needs at any time."
                }
              },
              {
                "@type": "Question",
                "name": "How much does emergency plumbing service cost in Kane County?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Emergency plumbing costs vary based on the nature and severity of the problem, time of day, and parts required. We provide upfront pricing before starting any work - no hidden fees or surprise charges. Emergency service may include after-hours fees, but we believe in transparent pricing."
                }
              },
              {
                "@type": "Question",
                "name": "Are your emergency plumbers licensed and insured?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Absolutely. All our emergency plumbers are fully licensed, insured, and bonded in Illinois. We carry comprehensive liability insurance and workers' compensation coverage to protect you and your property. Our plumbers undergo continuous training to stay current with the latest plumbing codes, techniques, and emergency response procedures."
                }
              },
              {
                "@type": "Question",
                "name": "What should I do while waiting for the emergency plumber?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "First, locate and shut off your main water valve if there's active flooding. Move valuables and electronics away from water. Place towels or buckets to contain water if possible. For gas leaks, evacuate immediately and call 911, then call us. Do not attempt DIY repairs on gas lines. Take photos for insurance documentation."
                }
              },
              {
                "@type": "Question",
                "name": "Do you service all areas of Kane County?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes, we provide emergency plumbing services throughout Kane County, IL, including Geneva, St Charles, South Elgin, Batavia, Elgin, North Aurora, Aurora, Montgomery, Sugar Grove, and all surrounding communities."
                }
              },
              {
                "@type": "Question",
                "name": "Can you help with insurance claims for water damage?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes, we frequently work with homeowners insurance companies. We provide detailed documentation of the emergency, photos of damage, itemized invoices, and professional assessments that support your insurance claim. We can also communicate directly with your insurance adjuster if needed."
                }
              }
            ]
          })}
        </script>
      </Head>

      <div className="min-h-screen bg-white">
        <Header currentPage="/services/emergency-plumbing-service" phoneNumber={phoneNumber} companyName={companyName} />

        {/* Sticky Emergency Contact Button */}
        <div className="fixed bottom-6 right-6 z-50">
          <a 
            href={`tel:${phoneNumber}`} 
            className="bg-red-600 text-white px-6 py-3 rounded-full shadow-lg hover:bg-red-700 transition-colors font-bold text-lg animate-bounce"
          >
            🚨 Emergency Call
          </a>
        </div>

        {/* Hero Section */}
        <section className="bg-gradient-to-r from-red-800 to-red-900 text-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Emergency Plumber Near Me - Geneva, IL | Kane County Emergency Plumbing
              </h1>
              <p className="text-xl md:text-2xl text-red-100 mb-8 max-w-3xl mx-auto">
                Licensed emergency plumber in Kane County providing 24/7 emergency plumbing services in Geneva, St Charles, South Elgin & all Kane County communities. Fast response for burst pipes, water leaks, drain clogs, sewage backups & all plumbing emergencies.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
                <a 
                  href={`tel:${phoneNumber}`} 
                  className="bg-yellow-500 text-slate-900 px-8 py-4 rounded-lg font-bold text-lg hover:bg-yellow-400 transition-colors animate-pulse"
                >
                  🚨 Emergency Call: {phoneNumber}
                </a>
                <Link 
                  href="/contact" 
                  className="bg-white text-slate-800 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors"
                >
                  📝 Request Emergency Service
                </Link>
              </div>
              <p className="text-red-200 text-sm">
                ⚡ 24/7 Emergency Response | 🚨 60-minute average arrival | 🛡️ Licensed & Insured Kane County Plumber
              </p>
            </div>
          </div>
        </section>

        {/* Emergency Services */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Emergency Plumbing Services Near Me - Kane County, IL</h2>
              <p className="text-xl text-gray-600">Emergency plumber handling all plumbing emergencies in Geneva, St Charles, South Elgin & Kane County, Illinois</p>
            </div>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[
                {
                  title: "Burst Pipe Emergency Repair",
                  description: "Immediate response for burst pipes causing flooding. Our licensed emergency plumber in Kane County provides 24/7 burst pipe repair to prevent extensive water damage and structural issues."
                },
                {
                  title: "Severe Drain Clogs & Blockages",
                  description: "Emergency drain cleaning services for severe clogs, main line blockages, and backed-up drains. We use professional hydro jetting and snake equipment to clear any obstruction quickly."
                },
                {
                  title: "Water Heater Failures",
                  description: "Emergency water heater repair and same-day replacement when your hot water is out. Our Kane County plumbers handle tank, tankless, and hybrid water heater emergencies."
                },
                {
                  title: "Sewer Line Backups & Overflows",
                  description: "Emergency sewer line clearing, repair, and cleaning for sewage backups. We respond immediately to prevent health hazards and property contamination throughout Kane County."
                },
                {
                  title: "Gas Line Emergencies & Leaks",
                  description: "Immediate emergency response to gas line leaks, gas odors, and safety concerns. Licensed gas line plumber providing urgent repairs to protect your family and home."
                },
                {
                  title: "Major Water Leaks & Flooding",
                  description: "Emergency leak detection and repair using advanced technology. Our emergency plumbers locate hidden leaks, stop water flow, and begin damage mitigation immediately."
                }
              ].map((service, index) => (
                <div key={index} className="bg-red-50 p-6 rounded-lg shadow-md border-l-4 border-red-500">
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">{service.title}</h3>
                  <p className="text-gray-600 mb-4">{service.description}</p>
                  <Link href="/contact" className="bg-red-600 text-white px-6 py-3 rounded-lg font-bold hover:bg-red-700 transition-colors inline-block">
                    Get Emergency Service
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Emergency Contact Section */}
        <section className="py-16 bg-red-700 text-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">🚨 Plumbing Emergency? Don't Wait!</h2>
            <p className="text-xl text-red-100 mb-8">
              Water damage gets worse every minute. Our licensed emergency plumbers in Kane County are standing by 24/7 to respond to your call immediately. We serve Geneva, St Charles, South Elgin, and all surrounding communities with professional emergency plumbing repair services.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-6">
              <a 
                href={`tel:${phoneNumber}`} 
                className="bg-yellow-500 text-slate-900 px-8 py-4 rounded-lg font-bold text-lg hover:bg-yellow-400 transition-colors animate-pulse"
              >
                🚨 Call Emergency Line: {phoneNumber}
              </a>
              <Link 
                href="/contact" 
                className="bg-white text-red-700 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors"
              >
                📋 Emergency Service Request
              </Link>
            </div>
            <p className="text-red-200 text-sm">
              ✅ Emergency Availability | ✅ Fast Response | ✅ Emergency Equipment Ready
            </p>
          </div>
        </section>

        {/* When to Call */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">When to Call Your Emergency Plumber in Kane County</h2>
              <p className="text-xl text-gray-600">Don't wait - these plumbing emergencies require immediate professional attention from a licensed plumber</p>
            </div>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                "No hot water in home",
                "Burst or broken pipes",
                "Sewage backup or overflow",
                "Gas smell or leak",
                "Major water leaks",
                "Overflowing toilets",
                "Frozen pipes in winter",
                "No water pressure"
              ].map((emergency, index) => (
                <div key={index} className="bg-white p-6 rounded-lg shadow-md border-l-4 border-red-500">
                  <div className="flex items-center">
                    <div className="w-6 h-6 bg-red-500 rounded-full flex-shrink-0 mr-3"></div>
                    <p className="text-gray-900 font-medium">{emergency}</p>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="text-center mt-8">
              <p className="text-lg text-gray-700 max-w-3xl mx-auto">
                If you're experiencing any of these plumbing emergencies in Kane County, Geneva, St Charles, or South Elgin, call our emergency plumber immediately at <a href={`tel:${phoneNumber}`} className="text-red-600 hover:text-red-800 font-bold">{phoneNumber}</a>. We provide 24/7 emergency plumbing services with rapid response times.
              </p>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Frequently Asked Questions - Emergency Plumber Kane County</h2>
              <p className="text-xl text-gray-600">Common questions about emergency plumbing services in Kane County, IL</p>
            </div>

            <div className="space-y-6">
              <div className="bg-gray-50 rounded-lg p-6 shadow-md">
                <h3 className="text-xl font-bold text-gray-900 mb-3">How fast can an emergency plumber get to my home in Kane County?</h3>
                <p className="text-gray-700 leading-relaxed">
                  Our emergency plumbers typically arrive within 60 minutes for most locations in Kane County, including Geneva, St Charles, and South Elgin. Response times may vary based on current demand and weather conditions, but we prioritize emergency calls and dispatch the nearest available licensed plumber to your location immediately.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6 shadow-md">
                <h3 className="text-xl font-bold text-gray-900 mb-3">What qualifies as a plumbing emergency?</h3>
                <p className="text-gray-700 leading-relaxed">
                  A plumbing emergency is any situation that poses immediate risk to your property, health, or safety. This includes burst pipes causing active flooding, sewage backups, gas leaks, no hot water in winter, frozen pipes at risk of bursting, major water leaks, complete loss of water, and overflowing toilets that won't stop. If you're unsure, call us - we can help assess the urgency of your situation.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6 shadow-md">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Do you provide 24/7 emergency plumbing service in Kane County?</h3>
                <p className="text-gray-700 leading-relaxed">
                  Yes! We offer 24-hour emergency plumbing services, 7 days a week, including nights, weekends, and holidays. Plumbing emergencies don't wait for business hours, and neither do we. Our emergency plumbers in Kane County are always on call and ready to respond to your urgent plumbing needs at any time.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6 shadow-md">
                <h3 className="text-xl font-bold text-gray-900 mb-3">How much does emergency plumbing service cost in Kane County?</h3>
                <p className="text-gray-700 leading-relaxed">
                  Emergency plumbing costs vary based on the nature and severity of the problem, time of day, and parts required. We provide upfront pricing before starting any work - no hidden fees or surprise charges. Emergency service may include after-hours fees, but we believe in transparent pricing. Call us at {phoneNumber} for a phone assessment and cost estimate.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6 shadow-md">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Are your emergency plumbers licensed and insured?</h3>
                <p className="text-gray-700 leading-relaxed">
                  Absolutely. All our emergency plumbers are fully licensed, insured, and bonded in Illinois. We carry comprehensive liability insurance and workers' compensation coverage to protect you and your property. Our plumbers undergo continuous training to stay current with the latest plumbing codes, techniques, and emergency response procedures.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6 shadow-md">
                <h3 className="text-xl font-bold text-gray-900 mb-3">What should I do while waiting for the emergency plumber?</h3>
                <p className="text-gray-700 leading-relaxed">
                  First, locate and shut off your main water valve if there's active flooding. Move valuables and electronics away from water. Place towels or buckets to contain water if possible. For gas leaks, evacuate immediately and call 911, then call us. Do not attempt DIY repairs on gas lines. Take photos for insurance documentation. Stay calm - help is on the way.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6 shadow-md">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Do you service all areas of Kane County?</h3>
                <p className="text-gray-700 leading-relaxed">
                  Yes, we provide emergency plumbing services throughout Kane County, IL, including Geneva, St Charles, South Elgin, Batavia, Elgin, North Aurora, Aurora, Montgomery, Sugar Grove, and all surrounding communities. If you're in Kane County and experiencing a plumbing emergency, we can help.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6 shadow-md">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Can you help with insurance claims for water damage?</h3>
                <p className="text-gray-700 leading-relaxed">
                  Yes, we frequently work with homeowners insurance companies. We provide detailed documentation of the emergency, photos of damage, itemized invoices, and professional assessments that support your insurance claim. We can also communicate directly with your insurance adjuster if needed. Our priority is stopping the damage and getting your plumbing system restored quickly.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Emergency Preparation Tips */}
        <section className="py-16 bg-blue-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Emergency Plumbing Prevention Tips for Kane County Homeowners</h2>
              <p className="text-xl text-gray-600">Prevent plumbing emergencies before they happen with these expert tips from your local plumber</p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-white rounded-lg p-6 shadow-md">
                <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mb-4">
                  <span className="text-white text-2xl font-bold">1</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Know Your Main Water Shutoff</h3>
                <p className="text-gray-600">
                  Every family member should know where the main water shutoff valve is located and how to turn it off. This single action can prevent thousands of dollars in water damage during a plumbing emergency.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-md">
                <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mb-4">
                  <span className="text-white text-2xl font-bold">2</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Winterize Pipes in Kane County</h3>
                <p className="text-gray-600">
                  Protect pipes from freezing during harsh Illinois winters. Insulate exposed pipes, disconnect garden hoses, drain outdoor faucets, and keep garage doors closed. Consider leaving cabinet doors open during extreme cold.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-md">
                <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mb-4">
                  <span className="text-white text-2xl font-bold">3</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Regular Plumbing Inspections</h3>
                <p className="text-gray-600">
                  Schedule annual plumbing inspections with a licensed plumber. We can identify potential problems before they become emergencies, including aging pipes, water heater issues, and hidden leaks.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-md">
                <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mb-4">
                  <span className="text-white text-2xl font-bold">4</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Watch What Goes Down Drains</h3>
                <p className="text-gray-600">
                  Prevent drain clogs by avoiding grease, coffee grounds, and food scraps in kitchen drains. Only flush toilet paper - no wipes, even "flushable" ones. Use drain strainers to catch hair and debris.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-md">
                <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mb-4">
                  <span className="text-white text-2xl font-bold">5</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Replace Old Water Heaters</h3>
                <p className="text-gray-600">
                  Water heaters typically last 10-12 years. If yours is approaching this age, consider replacement before it fails. Emergency water heater replacement is more expensive than planned replacement.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-md">
                <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mb-4">
                  <span className="text-white text-2xl font-bold">6</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Keep Our Number Handy</h3>
                <p className="text-gray-600">
                  Save our emergency plumber number in your phone: {phoneNumber}. In a plumbing emergency, every minute counts. Having quick access to a trusted plumber can minimize damage and stress.
                </p>
              </div>
            </div>

            <div className="text-center mt-12">
              <p className="text-lg text-gray-700 mb-6 max-w-3xl mx-auto">
                Need professional plumbing advice or preventive maintenance in Kane County? Our licensed plumbers are here to help you avoid costly emergencies.
              </p>
              <Link href="/contact" className="bg-blue-600 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-blue-700 transition-colors inline-block">
                Schedule Preventive Inspection
              </Link>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-red-800 text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Plumbing Emergency? We're Here to Help!
            </h2>
            <p className="text-xl text-red-100 mb-8 max-w-3xl mx-auto">
              Don't let a plumbing emergency ruin your day or damage your property. Our licensed emergency plumber team is standing by 24/7 throughout {serviceArea}. We're your trusted local emergency plumber in Kane County with the experience, equipment, and expertise to handle any plumbing crisis.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href={`tel:${phoneNumber}`} 
                className="bg-yellow-500 text-slate-900 px-8 py-4 rounded-lg font-bold text-lg hover:bg-yellow-400 transition-colors"
              >
                Call Emergency Line: {phoneNumber}
              </a>
              <Link 
                href="/contact" 
                className="bg-white text-slate-800 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors"
              >
                Request Emergency Service
              </Link>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-gray-900 text-white py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div>
                <h3 className="text-xl font-bold mb-4">{companyName}</h3>
                <p className="text-gray-300 mb-4">Professional plumbing services in {serviceArea}</p>
                <p className="text-gray-300">Licensed & Insured | Emergency Service Available</p>
              </div>
              <div>
                <h4 className="text-lg font-semibold mb-4">Services</h4>
                <ul className="space-y-2 text-gray-300">
                  <li><Link href="/services/emergency-plumbing-service" className="hover:text-white">Emergency Plumbing</Link></li>
                  <li><Link href="/services/broken-pipe" className="hover:text-white">Broken Pipe Repair</Link></li>
                  <li><Link href="/services/water-heater-replacement" className="hover:text-white">Water Heater Replacement</Link></li>
                  <li><Link href="/services" className="hover:text-white">All Services</Link></li>
                </ul>
              </div>
              <div>
                <h4 className="text-lg font-semibold mb-4">Contact</h4>
                <ul className="space-y-2 text-gray-300">
                  <li>Phone: <a href={`tel:${phoneNumber}`} className="hover:text-white">{phoneNumber}</a></li>
                  <li>Email: <a href="mailto:info@partnersinplumbing.com" className="hover:text-white">info@partnersinplumbing.com</a></li>
                  <li><Link href="/contact" className="hover:text-white">Contact Form</Link></li>
                </ul>
              </div>
            </div>
            <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
              <p>&copy; 2024 {companyName}. All rights reserved.</p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
} 